import React, {useMemo} from "../../../../../../__snowpack__/pkg/react.js";
import {Modal} from "../../../../../../__snowpack__/pkg/antd.js";
import styled from "../../../../../../__snowpack__/pkg/styled-components.js";
import {useIntl} from "../../../../../../__snowpack__/pkg/react-intl.js";
import {useUpdateRoute} from "../../../../../lib/useIframe.js";
export const RecommendedCheck = (props) => {
  const {formatMessage} = useIntl();
  const {categoryRecommend = []} = props;
  const {updateRouteTab} = useUpdateRoute();
  const selectCategory = (ids) => {
    Modal.confirm({
      title: "",
      content: /* @__PURE__ */ React.createElement(React.Fragment, null, formatMessage({id: "changingCategoryWillNotAffectYour"})),
      onOk: () => {
        props.onSelect(ids);
      }
    });
  };
  const RecommendedCategory = useMemo(() => {
    if (categoryRecommend.length > 0) {
      return categoryRecommend?.map((data) => {
        return {
          id: data.id,
          ids: data.categories.map((item) => {
            return item.externalCategoryId;
          }),
          names: data.categories.map((item) => {
            return item.name;
          })
        };
      });
    }
    return [];
  }, [categoryRecommend]);
  return categoryRecommend && categoryRecommend.length > 0 ? /* @__PURE__ */ React.createElement(CheckWrapper, null, /* @__PURE__ */ React.createElement("div", {
    className: "category-recommended-title"
  }, formatMessage({id: "basedOnTheTitleYouEntered"})), RecommendedCategory.map((data) => {
    return /* @__PURE__ */ React.createElement("div", {
      className: "category-recommended"
    }, /* @__PURE__ */ React.createElement("span", {
      onClick: () => {
        selectCategory(data.ids);
      }
    }, data.names?.join("/")));
  })) : /* @__PURE__ */ React.createElement(React.Fragment, null);
};
const CheckWrapper = styled.div`
  margin-bottom: 16px;
  width: 100%;
  .category-recommended-title {
    margin-bottom: 8px;
    font-size: 12px;
    font-weight: 400;
    color: #606c80;
    line-height: 20px;
  }
  .category-recommended {
    padding: 4px 0px;
    span {
      padding: 4px 8px;
      background: #f2f4f7;
      border-radius: 4px;
      color: #202d40;
      margin-top: 4px;
      cursor: pointer;
    }
  }
`;
